import { IBaseIngredient, INutrition } from "model/food/types/base.types"
import { v4 as uuidv4 } from "uuid"
import { getNutrition } from "./edamaForm"
import { IMyFood } from "model/food/types/myfood.types"
import { roundByDecimalPlace } from "utils"

const getGramWeightFromIngredients = <T extends { gram: null | number }>(
  ingredients: T[],
) => {
  const isGramInvalid = ingredients.some(
    (ingredient) => ingredient.gram === null || ingredient.gram === undefined,
  )

  if (isGramInvalid) {
    return null
  }

  const gram = ingredients.reduce(
    (acc, ingredient) => acc + (ingredient.gram as number),
    0,
  )

  return gram
}

export const getNutritionFromIngredients = <T extends INutrition>(
  ingredients: T[],
) => {
  const calorie = ingredients.reduce((acc, i) => acc + i.calorie, 0)
  const fat = ingredients.reduce((acc, i) => acc + i.fat, 0)
  const protein = ingredients.reduce((acc, i) => acc + i.protein, 0)
  const carbohydrate = ingredients.reduce((acc, i) => acc + i.carbohydrate, 0)
  const gram = getGramWeightFromIngredients(ingredients)

  return {
    calorie,
    fat,
    protein,
    carbohydrate,
    gram,
  }
}

export const updateIngredientsWhenPortionChange = <T extends IBaseIngredient>({
  ingredients,
  portion,
  nextPortion,
}: {
  ingredients: T[]
  portion: number
  nextPortion: number
}): T[] => {
  if (portion === 0) return ingredients

  const percent = nextPortion / portion

  return ingredients.map((ingredient) => {
    const nutrition = getNutrition(ingredient, percent)

    return {
      ...ingredient,
      ...nutrition,
      portion: roundByDecimalPlace(ingredient.portion * percent, 2),
    }
  })
}
